module.exports = __webpack_public_path__ + "static/media/muvn_logo.7cc532ae.png";